var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '../../utils';
import { renderIcon } from '../../utils/icon-utils';
import * as styles from './round-icon.styles';
var RoundIcon = function (_a) {
    var icon = _a.icon, iconSize = _a.iconSize, size = _a.size, imageUrl = _a.imageUrl, hexBackgroundColor = _a.hexBackgroundColor, backgroundColor = _a.backgroundColor, iconColor = _a.iconColor, className = _a.className, iconClassName = _a.iconClassName;
    return (_jsxs("div", __assign({ className: classNames(styles.roundIconContainer(size), className, "bg-".concat(backgroundColor), "text-".concat(iconColor)), style: hexBackgroundColor ? { backgroundColor: hexBackgroundColor } : {} }, { children: [imageUrl && (_jsx("img", { className: classNames(iconClassName, styles.roundIcon(iconSize)), src: imageUrl })), icon &&
                !imageUrl &&
                renderIcon(icon, classNames(iconClassName, styles.roundIcon(iconSize)))] })));
};
export { RoundIcon };
//# sourceMappingURL=round-icon.js.map